import { api } from "@/lib/apiClient";

export interface DefaultPrintLocationResponse {
  default_location_id?: number | null;
}

export async function getDefaultPrintLocation(): Promise<DefaultPrintLocationResponse> {
  return api.get<DefaultPrintLocationResponse>("/print/default-location", { cache: "no-store" });
}

export async function setDefaultPrintLocation(
  locationId: number | null,
): Promise<DefaultPrintLocationResponse> {
  const body = new URLSearchParams();
  if (locationId != null) body.set("location_id", String(locationId));
  return api.post<DefaultPrintLocationResponse>("/print/default-location", undefined, {
    rawBody: body,
  });
}

/** Nach erfolgreichem Druck – Backend speichert ebenfalls, dies ist ein zusätzlicher Client-Hinweis. */
export function rememberDefaultPrintLocation(locationId: number | null): void {
  if (locationId == null) return;
  void setDefaultPrintLocation(locationId).catch(() => {
    // Server speichert beim Druckauftrag; Fehler hier nicht blockieren.
  });
}
